import { render, staticRenderFns } from "./CarteraAtencionMedica.vue?vue&type=template&id=56130b2f&scoped=true"
import script from "./CarteraAtencionMedica.vue?vue&type=script&lang=js"
export * from "./CarteraAtencionMedica.vue?vue&type=script&lang=js"
import style0 from "./CarteraAtencionMedica.vue?vue&type=style&index=0&id=56130b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56130b2f",
  null
  
)

export default component.exports